const actionCreators = {
  setModalState(modalId, isOpen) {
    return {
      type: 'SET_MODAL_STATE',
      payload: {
        modalId,
        isOpen,
      },
    };
  },

  closeModal(modalId, options) {
    return {
      type: 'CLOSE_MODAL',
      payload: {
        modalId,
        ...options,
      },
    };
  },

  openModal(modalId, options) {
    return {
      type: 'OPEN_MODAL',
      payload: {
        modalId,
        ...options,
      },
    };
  },

  closeAllModals() {
    return {
      type: 'CLOSE_ALL_MODALS',
      payload: {},
    };
  },
};

export {
  actionCreators,
};
